import React, { useState } from 'react';
import axios from 'axios';
import FormLayout from '../Common/FormLayout'; // Subimos un nivel para entrar a Common
import { API_URLS } from '../../apiConfig';

//const API_BASE_URL = 'https://scagliacons.cloud/api/personas';

function PersonasForm(props) {
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        direccion: '',
        correo: '',
        numero_contacto: '',
        rol: 'usuario_stock',
        usuario: '',
        contrasena: ''
    });
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        setMessage('');
        setIsError(false);
        setLoading(true);

        try {
            await axios.post(API_URLS.PERSONAS, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            if (props.onPersonSaved) { 
                props.onPersonSaved(); 
            }

            setMessage('¡Persona agregada con éxito!');
            setFormData({
                nombre: '', apellido: '', direccion: '', correo: '',
                numero_contacto: '', rol: 'usuario_stock', usuario: '', contrasena: ''
            });

            // Limpiar mensaje después de 3 segundos
            setTimeout(() => setMessage(''), 3000);

        } catch (error) {
            console.error('Error al guardar persona:', error.response || error);
            setIsError(true);
            setMessage(error.response?.data?.message || 'Error al crear la persona.');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <FormLayout 
            title="Registro de Personal"
            description="Complete los datos para dar de alta un nuevo usuario en el sistema."
            icon="person-plus-fill"
            loading={loading}
            footer={
                <button 
                    type="submit" 
                    form="personas-main-form" 
                    className="btn-primary-modern flex items-center gap-2"
                    disabled={loading}
                >
                    <i className="bi bi-save"></i>
                    {loading ? 'Guardando...' : 'Guardar Persona'}
                </button>
            }
        >
            {/* Mensajes de feedback */}
            {message && (
                <div className={`mb-6 p-4 rounded-xl flex items-center gap-3 animate-fadeIn ${
                    isError ? 'bg-red-50 text-red-700 border border-red-100' : 'bg-green-50 text-green-700 border border-green-100'
                }`}>
                    <i className={`bi ${isError ? 'bi-exclamation-octagon' : 'bi-check-circle'}`}></i>
                    <span className="font-medium">{message}</span>
                </div>
            )}

            <form id="personas-main-form" onSubmit={handleSubmit} className="space-y-8">
                
                {/* SECCIÓN 1: DATOS PERSONALES */}
                                
                                    <div className="form-section-header">
                        Información Básica
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                        <div className="flex flex-col">
                            <label className="label-modern">Nombre</label>
                            <input 
                                type="text" 
                                name="nombre" 
                                className="input-modern" 
                                value={formData.nombre} 
                                onChange={handleChange} 
                                required 
                                placeholder="Ej: Juan" 
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="label-modern">Apellido</label>
                            <input 
                                type="text" 
                                name="apellido" 
                                className="input-modern" 
                                value={formData.apellido} 
                                onChange={handleChange} 
                                required 
                                placeholder="Ej: Pérez" 
                            />
                        </div>
                    </div>

                {/* SECCIÓN 2: CONTACTO Y ROL */}
                <div className="pt-6 border-t border-gray-100">
                  <div className="form-section-header">
                    Contacto y Permisos
                  </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="flex flex-col">
                            <label className="label-modern">Correo Electrónico</label>
                            <input type="email" name="correo" className="input-modern" value={formData.correo} onChange={handleChange} placeholder="correo@empresa.com" />
                        </div>
                        <div className="flex flex-col">
                            <label className="label-modern">Teléfono / WhatsApp</label>
                            <input type="text" name="numero_contacto" className="input-modern" value={formData.numero_contacto} onChange={handleChange} placeholder="+54..." />
                        </div>
                        <div className="flex flex-col">
                            <label className="label-modern">Rol Asignado</label>
                            <select name="rol" className="input-modern cursor-pointer" value={formData.rol} onChange={handleChange}>
                                <option value="administrador">Administrador</option>
                                <option value="usuario_stock">Usuario de Stock</option>
                                <option value="retiro_mercaderia">Retiro de Mercadería</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* SECCIÓN 3: CREDENCIALES */}
                <div className="pt-6 border-t border-gray-100">
                    <div className="form-section-header">
                        Credenciales de Acceso
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex flex-col">
                            <label className="label-modern">Nombre de Usuario</label>
                            <input type="text" name="usuario" className="input-modern" value={formData.usuario} onChange={handleChange} required autoComplete="off" placeholder="usuario.sistema" />
                        </div>
                        <div className="flex flex-col">
                            <label className="label-modern">Contraseña Inicial</label>
                            <input type="password" name="contrasena" className="input-modern" value={formData.contrasena} onChange={handleChange} required autoComplete="off" placeholder="••••••••" />
                        </div>
                    </div>
                </div>
            </form>
        </FormLayout>
    );
}

export default PersonasForm;